import React from "react";

const TabellaDominioPunteggi: React.FC = () => {
  const data = [
    {
      criterio: "ADESIONE AI MERCATI ITALIANI",
      metodologia: "Punteggio attribuito sulla base del conteggio del numero di mercati italiani a cui l'intermediario aderisce.",
      punti1: 10, range1: ">10 mercati",
      punti2: 8, range2: "9-10 mercati",
      punti3: 6, range3: "7-8 mercati",
      punti4: 4, range4: "5-6 mercati",
      punti5: 4, range5: "3-4 mercati",
      punti6: 1, range6: "1-2 mercati",
      punti7: 0, range7: "Nessun mercato",
    },
    {
      criterio: "ADESIONE AI MERCATI ESTERI",
      metodologia: "Punteggio attribuito sulla base del conteggio del numero di mercati esteri a cui l'intermediario aderisce.",
      punti1: 10, range1: "NEW YORK e/o LONDRA e/o XETRA e/o EQUIDUCT + altri 40 mercati",
      punti2: 8, range2: "NEW YORK e/o LONDRA e/o XETRA e/o EQUIDUCT + altri mercati per un numero compreso tra 20 e 40",
      punti3: 6, range3: "NEW YORK e/o LONDRA e/o XETRA e/o e/o EQUIDUCT +  altri mercati per un numero compreso tra 10 e 20;",
      punti4: 4, range4: "NEW YORK e/o LONDRA e/o XETRA e/o EQUIDUCT + altri mercati per un numero tra 5 e 10",
      punti5: 2, range5: "NEW YORK e/o LONDRA e/o XETRA e/o e/o EQUIDUCT + altri mercati per un numero tra 1 e 5",
      punti6: 1, range6: "Se ha almeno un mercato tra New York, Londra, Xetra, Equiduct",
      punti7: 0, range7: "Nessun mercato",
    },
    {
      criterio: "ALGORITMO DI BEST EXECUTION MERCATI AZIONARI",
      metodologia: "Punteggio attribuito sulla base del tipo di Best Execution rilevata per i mercati azionari. Nel caso in cui l'algoritmo utilizzi integrazioni tecniche come lo splitting, vengono attribuiti 2 punti di bonus.",
      punti1: 10, range1: "Best Execution Dinamica",
      punti2: 8, range2: "Best Execution Dinamica + Statica",
      punti3: 6, range3: "Best Execution Statica",
      punti4: 4, range4: "Best Execution non applicata o non dichiarata",
      punti5: "", range5: "",
      punti6: "", range6: "",
      punti7: "", range7: "",
    },
    {
      criterio: "ALGORITMO DI BEST EXECUTION MERCATI OBBLIGAZIONARI",
      metodologia: "Punteggio attribuito sulla base del tipo di Best Execution rilevata per i mercati obbligazionari. Nel caso in cui l'algoritmo utilizzi integrazioni tecniche come lo splitting, vengono attribuiti 2 punti di bonus.",
      punti1: 10, range1: "Best Execution Dinamica",
      punti2: 8, range2: "Best Execution Dinamica + Statica",
      punti3: 6, range3: "Best Execution Statica",
      punti4: 4, range4: "Best Execution non applicata o non dichiarata",
      punti5: "", range5: "",
      punti6: "", range6: "",
      punti7: "", range7: "",
    },
    {
      criterio: "ALGORITMO DI BEST EXECUTION MERCATI ITALIA",
      metodologia: "Punteggio attribuito sulla base del tipo di Best Execution rilevata per i mercati italiani. Nel caso in cui l'algoritmo utilizzi integrazioni tecniche come lo splitting, vengono attribuiti 2 punti di bonus.",
       punti1: 10, range1: "Best Execution Dinamica",
      punti2: 8, range2: "Best Execution Dinamica + Statica",
      punti3: 6, range3: "Best Execution Statica",
      punti4: 4, range4: "Best Execution non applicata o non dichiarata",
      punti5: "", range5: "",
      punti6: "", range6: "",
      punti7: "", range7: "",
    },
    {
      criterio: "ALGORITMO DI BEST EXECUTION MERCATI ESTERI",
      metodologia: "Punteggio attribuito sulla base del tipo di Best Execution rilevata per i mercati esteri.Nel caso in cui l'algoritmo utilizzi integrazioni tecniche come lo splitting, vengono attribuiti 2 punti di bonus.",
      punti1: 10, range1: "Best Execution Dinamica",
      punti2: 8, range2: "Best Execution Dinamica + Statica",
      punti3: 6, range3: "Best Execution Statica",
      punti4: 4, range4: "Best Execution non applicata o non dichiarata",
      punti5: "", range5: "",
      punti6: "", range6: "",
      punti7: "", range7: "",
    },
    {
      criterio: "INDICE DI PENETRAZIONE DEI MERCATI AMF CASH",
      metodologia: "Punteggio attribuito sulla base dell'indice di penetrazione per i mercati cash calcolato a partire dai dati estratti dal report AMF Italia.",
      punti1: 10, range1: "Superiore a 10%",
      punti2: 8, range2: ">=8% e <10%",
      punti3: 6, range3: ">=6% e <8%",
      punti4: 4, range4: ">=4% e <6%",
      punti5: 2, range5: ">=2% e <4%",
      punti6: 1, range6: ">0 e <2%",
      punti7: "", range7: "",
    },
    {
      criterio: "INDICE DI PENETRAZIONE DEI MERCATI AMF DERIVATI",
      metodologia: "Punteggio attribuito sulla base dell'indice di penetrazione per i mercati derivati calcolato a partire dai dati estratti dal report AMF Italia.",
      punti1: 10, range1: "Superiore a 10%",
      punti2: 8, range2: ">=8% e <10%",
      punti3: 6, range3: ">=6% e <8%",
      punti4: 4, range4: ">=4% e <6%",
      punti5: 2, range5: ">=2% e <4%",
      punti6: 1, range6: ">0 e <2%",
      punti7: "", range7: "",
    },
    {
      criterio: "TRASPARENZA INFORMATIVA",
      metodologia: "Punteggio attribuito sulla base del tipo di disclosures effettuata dall'intermediario in merito ai costi.",
      punti1: 10, range1: "Strategia pubblicata con suddivisione delle commisioni tra Banca trasmettitrice e Intermediario negoziatore",
      punti2: 8, range2: "Strategia pubblicata con i costi complessivi senza alcuna suddivisione delle commisioni tra Banca trasmettitrice e Intermediario negoziatore",
      punti3: 4, range3: "Strategia pubblicata senza alcuna indicazione di costi",
      punti4: 0, range4: "Nessuna strategia pubblicata",
      punti5: "", range5: "",
      punti6: "", range6: "",
      punti7: "", range7: "",
    },
    {
      criterio: "SOLIDITÀ",
      metodologia: "Punteggio attribuito sulla base del coefficiente patrimoniale CET1 dell'intermediario.",
      punti1: 10, range1: "CET1 ≥13%",
      punti2: 8, range2: "12.5% ≤ CET1 < 13%",
      punti3: 6, range3: "12% ≤ CET1 < 12.5%",
      punti4: 4, range4: "11.5% ≤ CET1 < 12%",
      punti5: 2, range5: "11% ≤ CET1 < 11.5%",
      punti6: 0, range6: "10.5% ≤ CET1 < 11%",
      punti7: -2, range7: "CET1 < 10.5%",
    },
    {
      criterio: "RECLAMI",
      metodologia: "Punteggio attribuito sulla base della percentuale dei reclami relativi ai servizi di investimento sul totale (considerate solamente le fonti aggiornate). ",
      punti1: 10, range1: "Nessun reclamo",
      punti2: 6, range2: "1%-5%",
      punti3: 4, range3: "5%-10%",
      punti4: 2, range4: ">10%",
      punti5: 0, range5: "Rendiconto sui Reclami non pubblicato",
      punti6: "", range6: "",
      punti7: "", range7: "",
    },
    {
      criterio: "MARKET MAKER",
      metodologia: "Punteggio attribuito sulla base dell'adesione al servizio di Market Making. Attribuzione di un bonus pari a 2 punti per ogni aset class trattata.",
      punti1: 5, range1: "Adesione al servizio di Market Making",
      punti2: 0, range2: "Mancata prestazione del servizio di Market Making",
      punti3: "", range3: "",
      punti4: "", range4: "",
      punti5: "", range5: "",
      punti6: "", range6: "",
      punti7: "", range7: "",
    },
    {
      criterio: "ESG",
      metodologia: "Punteggio attribuito sulla base dell'aggregazione della componente GAR (40%) e della componente Score ESG (60%). Entrambe le componenti sono valutate su una scala da 1 a 5, il punteggio finale si ottiene approssimando all'intero più vicino la media pesata delle due componenti. In caso di indisponibilità del dato di almeno uno dei due GAR, il punteggio della componente GAR è uguale a 0. Altresì, in caso di indisponibilità del rating ESG, il punteggio della componente rating ESG è uguale a 0.",
      punti1: 5, range1: "",
      punti2: 4, range2: "",
      punti3: 3, range3: "",
      punti4: 2, range4: "",
      punti5: 1, range5: "",
      punti6: "", range6: "",
      punti7: "", range7: "",
    },
  ];

  return (
    <div className="mt-8">
      <h2 className="text-xl font-bold mb-6 pl-2">
        TABELLA DEL DOMINIO DEI PUNTEGGI
      </h2>
      <div className="overflow-x-auto bg-surface rounded-lg shadow-md">
        <table className="min-w-full border-collapse">
          {/* L'intestazione è ora su una singola riga */}
          <thead className="bg-gray-50 text-xs text-textSecondary font-semibold border-b border-divider">
            <tr className="bg-white text-textSecondary text-xxs">
              {/* Criterio e Metodologia */}
              <th className="py-2 px-2 text-left font-semibold border-r border-divider ">Criterio di valutazione</th>
              <th className="py-2 px-2 text-left font-semibold border-r border-divider ">Metodologia da applicare per il calcolo</th>
              
              {/* I 14 campi Punteggio/Range con testo completo e whitespace-nowrap */}
              {Array.from({ length: 7 }, (_, i) => (
                <React.Fragment key={i}>
                  <th className="py-2 px-2 text-center font-semibold border-r border-divider whitespace-nowrap">PUNTEGGIO {i + 1}</th>
                  <th className="py-2 px-2 text-center font-semibold border-r border-divider whitespace-nowrap">RANGE {i + 1}</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody className="text-xs text-textPrimary">
            {data.map((row, index) => (
              <tr key={index} className="border-b border-divider even:bg-gray-50">
                <td className="py-4 px-2 font-medium border-r border-divider text-left">{row.criterio}</td>
                <td className="py-4 px-2 border-r border-divider text-left text-xs">{row.metodologia}</td>
                
                <td className="py-4 px-2 border-r border-divider text-xxs">{row.range1}</td>
                <td className="py-4 px-2 text-center border-r border-divider">{row.punti1}</td>
                
                                <td className="py-4 px-2 border-r border-divider text-xxs">{row.range2}</td>
                <td className="py-4 px-2 text-center border-r border-divider">{row.punti2}</td>
                
                                <td className="py-4 px-2 border-r border-divider text-xxs">{row.range3}</td>
                <td className="py-4 px-2 text-center border-r border-divider">{row.punti3}</td>
                
                <td className="py-4 px-2 border-r border-divider text-xxs">{row.range4}</td>
                                <td className="py-4 px-2 text-center border-r border-divider">{row.punti4}</td>

                                <td className="py-4 px-2 border-r border-divider text-xxs">{row.range5}</td>
                <td className="py-4 px-2 text-center border-r border-divider">{row.punti5}</td>
                            
                                <td className="py-4 px-2 border-r border-divider text-xxs">{row.range6}</td>
                <td className="py-4 px-2 text-center border-r border-divider">{row.punti6}</td>
                
                <td className="py-4 px-2 border-r border-divider text-xxs">{row.range7}</td>
                                <td className="py-4 px-2 text-center border-r border-divider">{row.punti7}</td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TabellaDominioPunteggi;